export default __webpack_public_path__ + "static/media/World_s First Decentralized.40ae854f.png";